/* eslint-disable import/prefer-default-export */
import {
  SYS_ADMIN,
  FOCUSED_OPERATOR,
  ADMIN,
  OPERATOR,
  SUPERVISOR,
  VIEW_ONLY_OPERATOR,
} from '../constants/roles';
import { capitalizeEachWord } from './format';
import i18n from '@app/i18n';

// Standalone roles cannot coexist with base roles or with each other, so
// assigning one strips any conflicting roles.
const BASE_ROLES = [SYS_ADMIN, ADMIN, OPERATOR, SUPERVISOR];
const STANDALONE_ROLES = [FOCUSED_OPERATOR, VIEW_ONLY_OPERATOR];

export const constructRoleChangeText = (currentRoles = [], newRoles = []) => {
  let removedRoles = [];
  if (newRoles.some((role) => STANDALONE_ROLES.includes(role))) {
    removedRoles = currentRoles.filter(
      (role) =>
        BASE_ROLES.includes(role) ||
        (STANDALONE_ROLES.includes(role) && !newRoles.includes(role)),
    );
  } else if (newRoles.some((role) => BASE_ROLES.includes(role))) {
    removedRoles = currentRoles.filter((role) =>
      STANDALONE_ROLES.includes(role),
    );
  }
  return removedRoles.length > 0
    ? i18n.t('teamManagement:users.assignRole.roleChangeToast', {
        newRoles: capitalizeEachWord(newRoles.join(', ')?.toLowerCase()),
        removedRoles: capitalizeEachWord(
          removedRoles.join(', ')?.toLocaleLowerCase(),
        ),
        count: removedRoles.length,
      })
    : '';
};
